import { Pipe, PipeTransform } from '@angular/core';

import { ToPlainText } from '@empathy/global/functions';

@Pipe({
  name: 'toPlainText',
  pure: true
})
export class ToPlainTextPipe implements PipeTransform {
  transform(htmlText: string): string {
    return ToPlainText(htmlText);
  }
}
